export const environment = {
	appName: 'Wap',
	home: '/painel/user',
	production: true,

	api: 'https://api-mais.wap.ind.br/api/1.0',
	url: 'https://web-mais.wap.ind.br',

	passwordRules: {
		minlength: 6,
		minLowercaseCharacterRule: 1,
		minUppercaseCharacterRule: 1,
		minDigitCharacterRule: 1,
		minSpecialCharacterRule: 1
	},
	firebaseConfig: {
		apiKey: "AIzaSyCmkE34PXc7xzfspa_PZIN6cJvQxCYSfmc",
		authDomain: "lumini-vendas.firebaseapp.com",
		projectId: "lumini-vendas",
		storageBucket: "lumini-vendas.firebasestorage.app",
		messagingSenderId: "531203285550",
		appId: "1:531203285550:web:177a77397708846aa935bf"
	},

	title: 'Wap',
	description: ``,
	image: '',
	keywords: ''
};
